import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Card, CardHeader, Button, ListGroup, ListGroupItem, Progress } from 'shards-react';
import Avatar from 'react-avatar';
import { auth, getUserClaims } from '../../firebase-init';

const UserDetails = (props) => {
  const { userDetails } = props;

  return (
    <Card small className="mb-4 pt-3">
      <CardHeader className="border-bottom text-center">
        <div className="mb-3 mx-auto">
          <Avatar name={`${userDetails.firstname} ${userDetails.lastname}`} size="110" round={true} />
        </div>
        <h4 className="mb-0">{`${userDetails.firstname} ${userDetails.lastname}`}</h4>
        <span className="text-muted d-block mb-2">{userDetails.role} </span>
      </CardHeader>
    </Card>
  );
};

export default UserDetails;
